/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability.ts";
import { individualPaymentTraceabilityViewModelSchema } from "../individualPaymentTraceabilityViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability200Schema =
  z.array(
    z.lazy(() => individualPaymentTraceabilityViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse>;
